import ParsedDecoratorChildren from "../components/ParsedDecoratorChildren";
import { REGEX_ITALIC } from "../regex";
import { jsx as _jsx } from "react/jsx-runtime";
var Italic = function Italic(_ref) {
  var offsetKey = _ref.offsetKey,
    decoratedText = _ref.decoratedText,
    isDark = _ref.isDark;
  var text = decoratedText.match(REGEX_ITALIC) ? decoratedText.substring(2, decoratedText.length - 2) : decoratedText;
  return /*#__PURE__*/_jsx("i", {
    className: "italic",
    "data-offset-key": offsetKey,
    children: /*#__PURE__*/_jsx(ParsedDecoratorChildren, {
      text: text,
      isDark: isDark
    })
  });
};
export default Italic;